import { render, staticRenderFns } from "./JournalChip.vue?vue&type=template&id=53de0ce4&functional=true&"
import script from "./JournalChip.vue?vue&type=script&lang=js&"
export * from "./JournalChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports